import { useEffect, useContext, forwardRef, useState } from 'react';
import { Modal, Slider, List, Input, Select } from 'antd';
import Graphin, { Behaviors, GraphinContext } from '@antv/graphin';
import { Legend, Tooltip, Toolbar } from '@antv/graphin-components';
import * as _ from 'lodash';
import { DataCenterContext } from './DataCenter';
// import '@antv/graphin-components/dist/index.css'; // Graphin 组件 CSS

const { DragNodeWithForce, ClickSelect } = Behaviors;

function opLog(message) {
  fetch('/news_operation_log', {
    method: 'POST',
    headers: {
      'content-type': 'application/json;charset=utf-8'
    },
    body: JSON.stringify({ message })
  }).then(resp => resp.status === 200 ? resp.json() : false)
    .catch(console.log)
}

function updateLayout(graph, layout) {
  layout.instance.simulation.stop()
  const data = layout.getDataFromGraph()
  graph.emit('nodeVisibilityChange', data.nodes.length)
  layout.instance.simulation.setData(data)
  layout.start()
}
function ToolLayer({ edgeDbClick }) {
  const { graph, layout } = useContext(GraphinContext);
  const data = graph.save()
  const weights = Array.from(new Set(data.edges.map(({ data }) => data.weight))).sort()
  useEffect(() => {
    const fc = (e) => {
      console.log(e)
      const container = document.getElementById('graphin-container')
      graph.changeSize(container.clientWidth, container.clientHeight)
      graph.fitCenter();
      graph.fitView(0);
    }
    graph.on('edge:click', edgeClick);
    graph.on('edge:dblclick', edgeDbClick);
    graph.on('afterlayout', fc);
    ['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange'].forEach((item, index) => {
      window.addEventListener(item, fc);
    })
    return () => {
      graph.off('edge:click', edgeClick);
      graph.off('edge:dblclick', edgeDbClick);
      graph.off('afterlayout', fc);
      ['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange'].forEach((item, index) => {
        window.removeEventListener(item, fc);
      })
    }
  }, []);
  function changeLegend(opt) {
    graph.findAll('node', node => node.getModel().data.type === opt.value).forEach(node => opt.checked ? graph.showItem(node) : graph.hideItem(node))
    updateLayout(graph, layout)
  }
  function changeSlider(value) {
    graph.getEdges().forEach(edge => {
      const ed = edge.getModel()
      edge.setState('inactive', ed.data.weight < weights[value])
    })
    graph.getNodes().forEach(node => {
      node.setState('inactive', node.getEdges().every(edge => edge.hasState('inactive')))
    })
  }

  return <>
    <Legend bindType="node" sortKey="data.type" colorKey="style.keyshape.stroke" style={{ bottom: 10, top: null }}  >
      <Legend.Node onChange={changeLegend} style={{ fontSize: '16px' }} />
    </Legend>
    <div style={{
      position: 'absolute', top: 12, left: 12, width: 144
    }}>
      <p>删掉多少句话：</p>
      <Slider defaultValue={0} max={weights.length - 1} onAfterChange={changeSlider} />
      <NodeList />
    </div>
  </>;
}
function NodeBehavior() {
  let firstClick = true
  const [mode, setMode] = useState('active')
  const [{ tabKey, text }, update] = useContext(DataCenterContext)
  const { graph, layout } = useContext(GraphinContext);
  useEffect(() => {
    graph.on('canvas:click', canvasClick);
    graph.on('node:click', nodeClick);
    graph.on('edge:click', edgeClick);
    return () => {
      graph.off('canvas:click', canvasClick)
      graph.off('node:click', nodeClick)
      graph.off('edge:click', edgeClick)
    }
  });
  function nodeClick(evt) {
    if (mode === 'active') {
      if (firstClick) {
        firstClick = false
        graph.getEdges().forEach(edge => {
          edge.setState('inactive', true)
        })
        graph.getNodes().forEach(node => {
          node.setState('inactive', true)
        })
      }
      if (evt.item.hasState('inactive')) {
        graph.getEdges().forEach(edge => {
          edge.clearStates('active')
          edge.setState('inactive', true)
        })
        graph.getNodes().forEach(node => {
          node.clearStates('active')
          node.setState('inactive', true)
        })
      }
      evt.item.getEdges().forEach(edge => {
        edge.clearStates('inactive')
        edge.setState('active', true)
      })
      evt.item.getNeighbors().forEach(node => {
        node.clearStates('inactive')
        node.setState('active', true)
      })
    }
    evt.item.clearStates('inactive')
    evt.item.setState(mode, true)
  }
  function edgeClick(evt) {
    if (mode === 'active') {
      return
    }
    evt.item.clearStates('inactive')
    evt.item.setState(mode, true)
  }
  function canvasClick(evt) {
    firstClick = true
    graph.getEdges().forEach(edge => {
      edge.clearStates(['inactive', 'active', 'selected'])
    })
    graph.getNodes().forEach(node => {
      node.clearStates(['inactive', 'active', 'selected'])
    })
  }
  function tiggerCoref() {
    graph.findAll('edge', edge => edge.getModel().data.type === 'coref').forEach(edge => edge.changeVisibility(!edge.isVisible()))
    graph.getNodes().forEach(node => node.changeVisibility(node.getEdges().some(edge => edge.isVisible())))
    updateLayout(graph, layout)
  }
  function updateGraph() {
    const graphData = graph.save()
    update({
      [tabKey]: {
        words: graphData.nodes.map(node => node.data),
        relations: graphData.edges.map(edge => edge.data)
      }
    })
  }
  return <Toolbar style={{ right: 10, top: 10 }}>
    <Toolbar.Item
      onClick={() => { document.fullscreenElement ? document.exitFullscreen() : document.getElementById('graphin-container').requestFullscreen() }}
    >全屏开关</Toolbar.Item>
    <Toolbar.Item
      onClick={tiggerCoref}
    >coref开关</Toolbar.Item>
    <Toolbar.Item><Select
      defaultValue="active"
      getPopupContainer={triggerNode => triggerNode.parentElement}
      onChange={value => {
        setMode(value)
        canvasClick()
      }}
      options={[{ label: '探索模式', value: 'active' }, { label: '选择模式', value: 'selected' }]}
    /></Toolbar.Item>
    <Toolbar.Item onClick={() => {
      const selected_nodes = graph.findAllByState('node', 'selected')
      const target = selected_nodes[0]
      if (!target || !target.hasState('selected')) {
        return;
      }
      let data = target.getModel()
      const ori_data = selected_nodes.map(node => ({ ...node.getModel().data }))
      selected_nodes.forEach(node => {
        if (node === target) {
          return;
        }
        const nodeModel = node.getModel()
        data = _.merge(nodeModel, data, {
          data: { weight: data.data.weight + nodeModel.data.weight },
          size: data.size + nodeModel.size
        })
        node.getInEdges().forEach(edge => {
          const model = edge.getModel()
          model.target = model.data.target = data.id
          edge.update(model)
          edge.setTarget(target)
        })
        node.getOutEdges().forEach(edge => {
          const model = edge.getModel()
          model.source = model.data.source = data.id
          edge.update(model)
          edge.setSource(target)
        })
        graph.removeItem(node)
      })
      target.update(data)
      target.draw(data)
      updateGraph()
      canvasClick()
      opLog(`[title:${text.title}] - type:${tabKey} - merge:node - ${JSON.stringify(ori_data)} - ${JSON.stringify(data.data)}`)
    }}>合并节点</Toolbar.Item>
    <Toolbar.Item onClick={() => {
      const nodes = graph.findAllByState('node', 'selected')
      const ori_data = nodes.map(node => node.getModel().data)
      nodes.forEach(graph.remove.bind(graph))
      updateGraph()
      opLog(`[title:${text.title}] - type:${tabKey} - remove:node - ${JSON.stringify(ori_data)}`)
    }}>删除节点</Toolbar.Item>
    <Toolbar.Item onClick={() => {
      let [target, source] = graph.findAllByState('node', 'selected');
      if (!target || !source) return
      target = target.getModel().id
      source = source.getModel().id
      Modal.info({
        maskClosable: true,
        getContainer: '#graphin-container',
        title: `关系：`,
        content: <Input id='input-rel' />,
        onOk: () => {
          const type = document.getElementById('input-rel').value
          console.log(target, source);
          const edge = graph.addItem('edge', {
            source,
            target,
            data: {
              source,
              target,
              type
            }, label: global.colorMap[type] ? false : {
              fill: 'black',
              fontSize: 16,
              offset: [0, 0],
              value: type
            }
          })
          canvasClick()
          // updateLayout(graph, layout)
          updateGraph()
          opLog(`[title:${text.title}] - type:${tabKey} - add:edge - ${JSON.stringify(edge.getModel().data)}`)
        }
      })
    }}>增加边</Toolbar.Item>
    <Toolbar.Item onClick={() => {
      const edges = graph.findAllByState('edge', 'selected')
      const ori_data = edges.map(edge => edge.getModel().data)
      edges.forEach(graph.remove.bind(graph))
      updateGraph()
      opLog(`[title:${text.title}] - type:${tabKey} - remove:edge - ${JSON.stringify(ori_data)}`)
    }}>删除边</Toolbar.Item>
  </Toolbar >
}
function NodeList() {
  const { graph, apis } = useContext(GraphinContext);
  const [, setCounter] = useState(-1)
  const [flt, setFlt] = useState('')
  const nodes = graph
    .findAll('node', node => node.isVisible())
    .map(node => node.getModel())
    .filter(item => item.data.word.includes(flt))
    .sort((a, b) => b.data.weight - a.data.weight)
  useEffect(() => {
    graph.on('nodeVisibilityChange', setCounter);
    return () => {
      graph.off('nodeVisibilityChange', setCounter)
    }
  }, []);
  function focusNode(id) {
    const item = graph.findById(id)
    if (!item) {
      return
    }
    graph.emit('node:click', { item })
    apis.focusNodeById(id)
  }
  return <>
    <Input.Search
      placeholder="输入节点"
      onChange={evt => setFlt(evt.target.value)}
      onSearch={() => focusNode(nodes[0]?.id)}
      enterButton />
    <List
      itemLayout="vertical"
      size="large"
      dataSource={nodes}
      pagination={{
        defaultPageSize: 10,
        size: 'small',
        showLessItems: true
      }}
      renderItem={({ id, data: item }) =>
        <List.Item
          key={item.word}
          onClick={() => {
            focusNode(id)
          }}
        >
          <span style={{
            backgroundColor: global.colorMap[item.type],
            padding: '0 4px',
            fontWeight: 600,
          }}>{item.word} {/*item.weight.toFixed(2)*/}</span>
        </List.Item>
      }
    />
  </>
}
const edgeClick = evt => {
  const data = evt.item.getModel().data
  if (!data?.spans?.length) {
    return
  }
  const prev = document.querySelector('p[high]')
  if (prev) {
    prev.removeAttribute('high')
    prev.style.background = ''
  }
  const sentence_id = `sentence${data.spans.length ? data.spans[0][0] : ""}`
  const curr = document.getElementById(sentence_id)
  if (curr) {
    curr.scrollIntoView()
    curr.style.background = 'yellow'
    curr.setAttribute('high', '')
  }
}
const RelView = forwardRef((props, ref) => {
  const { graph, sentences } = props;
  const edgeDbClick = evt => {
    const data = evt.item.getModel().data
    const source = evt.item.getSource().getModel().data
    const target = evt.item.getTarget().getModel().data
    if (data.type === 'extension') {
      return
    }
    Modal.info({
      maskClosable: true,
      getContainer: '#graphin-container',
      title: `关系：${source.word} - ${target.word}`,
      content: data?.spans?.map(([sid, s, t, r]) => {
        const sentence = sentences[sid].content
        let offset = sentences[sid].span[0]
        const style = {
          fontWeight: 600,
          background: 'yellow'
        }
        if (r) {
          return <p>
            <b>sentence-{sid}: </b>
            {sentence.substring(0, s[0] - offset)}
            <span style={style}>{sentence.substring(s[0] - offset, s[1] - offset)}</span>
            {sentence.substring(s[1] - offset, r[0] - offset)}
            <span style={{
              ...style,
              background: 'pink'
            }}>{sentence.substring(r[0] - offset, r[1] - offset)}</span>
            {sentence.substring(r[1] - offset, t[0] - offset)}
            <span style={style}>{sentence.substring(t[0] - offset, t[1] - offset)}</span>
            {sentence.substring(t[1] - offset)}
          </p>
        } else {
          return <>
            <p>
              <b>sentence-{sid}: </b>
              {sentence.substring(0, s[0] - offset)}
              <span style={style}>{sentence.substring(s[0] - offset, s[1] - offset)}</span>
              {sentence.substring(s[1] - offset, t[0] - offset)}
              <span style={style}>{sentence.substring(t[0] - offset, t[1] - offset)}</span>
              {sentence.substring(t[1] - offset)}
            </p>
            {sentences[sid].triples.map(tri => <p>（{tri.map(x => `【${x}】`).join('，')}）</p>)}
          </>
        }
      })
    })
  }
  const data = {
    nodes: graph.words.map(data => ({
      id: data.id,
      label: data.word,
      data,
      style: {
        keyshape: {
          stroke: global.colorMap[data.type],
          fill: global.colorMap[data.type],
          fillOpacity: 0.3,
          size: 100,
        },
        label: {
          value: data.word.length > 5 ? data.word.substring(0, 4) + '...' : data.word,
          position: 'center',
          offset: [0, 7],
          fontSize: 20
        }
      }
    })),
    edges: graph.relations.map(data => ({
      source: data.source,
      target: data.target,
      data,
      style: {
        keyshape: {
          stroke: global.colorMap[data.type],
          strokeOpacity: 0.6
        },
        label: global.colorMap[data.type] ? false : {
          fill: 'black',
          fontSize: 16,
          offset: [0, 0],
          value: data.type
        }
      }
    })),
  }
  console.log(data)
  const config = {
    data,
    ref,
    layout: {
      defSpringLen(edge, source, target) {
        return (source.data.style.keyshape.size + target.data.style.keyshape.size) / 2 + 200
      },
      type: 'graphin-force',
      ignore: node => node.isVisible && !node.isVisible(),
    },
  }
  return <Graphin {...config}>
    <DragNodeWithForce autoPin={false} />
    <ToolLayer {...data} edgeDbClick={edgeDbClick} />
    <NodeBehavior />
    <ClickSelect disabled />
    <Tooltip bindType="node" placement="center" hasArrow={true}>
      <Tooltip.Node>
        {model => {
          return (
            <div>
              {model.id}
              <li>{model.label}</li>
              {model.data?.info?.abstract}
            </div>
          );
        }}
      </Tooltip.Node>
    </Tooltip>
  </Graphin>
})
export default RelView